/**
 * Tab Switcher for Universal Form
 *
 * Handles switching between online/distance tabs
 * 
 * @package DesignSchool\Forms
 */

declare var jQuery: any;

export class TabSwitcher {
    private $: any;

    constructor() {
        this.$ = jQuery;
        this.init();
    }

    /**
     * Initialize tab switcher
     */
    private init(): void {
        // Watch for program_type select change (БЭМ: ds-form__select with data-tab-switcher)
        this.$(document).on('change', '[name="program_type"][data-tab-switcher="true"], select[name="program_type"]', (e: Event) => {
            const $select = this.$(e.target);
            const tabType = $select.val() as string; // 'och' or 'dist'
            
            if (tabType) {
                this.switchTab(tabType);
            }
        });

        // Also watch for tab button clicks (legacy support)
        this.$(document).on('click', '.form-tabs .tab-button', (e: Event) => {
            e.preventDefault();
            
            const $button = this.$(e.target);
            const tabType = $button.data('tab-type'); // 'och' or 'dist'
            
            this.switchTab(tabType);
            
            // Update select if exists
            const $form = this.$('.ds-form[data-form-id="form_program"]');
            $form.find('[name="program_type"]').val(tabType);
        });

        // Initialize on form load
        this.$(document).on('form-loaded', () => {
            const $form = this.$('.ds-form[data-form-id="form_program"]');
            if ($form.length) {
                const currentType = $form.find('[name="program_type"]').val() as string || 'och';
                this.switchTab(currentType);
            }
        });
    }

    /**
     * Switch active tab
     */
    private switchTab(type: string): void {
        const $form = this.$('.ds-form[data-form-id="form_program"]');
        
        if (!$form.length) {
            return;
        }

        // Update tab buttons (if exist)
        this.$('.form-tabs .tab-button').removeClass('active');
        this.$(`.form-tabs .tab-button[data-tab-type="${type}"]`).addClass('active');

        // Show/hide appropriate selects and fields (БЭМ: ds-form__field with data-tab)
        $form.find('.ds-form__field[data-tab="och"], [data-tab="och"]').each((_: number, el: HTMLElement) => {
            const $el = this.$(el);
            if (type === 'och') {
                $el.closest('.ds-form__field').show();
                $el.prop('disabled', false);
            } else {
                $el.closest('.ds-form__field').hide();
                $el.prop('disabled', true);
            }
        });

        $form.find('.ds-form__field[data-tab="dist"], [data-tab="dist"]').each((_: number, el: HTMLElement) => {
            const $el = this.$(el);
            if (type === 'dist') {
                $el.closest('.ds-form__field').show();
                $el.prop('disabled', false);
            } else {
                $el.closest('.ds-form__field').hide();
                $el.prop('disabled', true);
            }
        });

        // Clear values of hidden tab
        const hiddenTab = type === 'och' ? 'dist' : 'och';
        $form.find(`[data-tab="${hiddenTab}"]`).val('');

        console.log('[TabSwitcher] Switched to:', type);
    }

    /**
     * Get active tab
     */
    public getActiveTab(): string {
        const $form = this.$('.ds-form[data-form-id="form_program"]');
        if ($form.length) {
            return $form.find('[name="program_type"]').val() as string || 'och';
        }
        return this.$('.form-tabs .tab-button.active').data('tab-type') || 'och';
    }

    /**
     * Set active tab programmatically
     */
    public setActiveTab(type: string): void {
        this.switchTab(type);
    }
}

// Export singleton
export const tabSwitcher = new TabSwitcher();






